const config = {
  zoom: 18,
  maxZoom: 24,
  minZoom: 14,
};
export default config;
